import React from 'react';

const SvgFlecheBasPetite = (props: any) => (
<svg viewBox="0 0 73.6 148.5" {...props}>
<polygon points="67,102.7 41.3,130.4 41.3,0 32.3,0 32.3,130.4 6.6,102.7 0,108.9 36.8,148.5 73.6,108.9 "/>
</svg>
);

export default SvgFlecheBasPetite;
